// extracted by mini-css-extract-plugin
export var allNewsItemsLink = "news-module--allNewsItemsLink--hL+Ju";
export var enlargedImage = "news-module--enlargedImage--uFKNi";
export var images = "news-module--images--UmGNJ";
export var left = "news-module--left--fUpfb";
export var news = "news-module--news--Scgfj";
export var right = "news-module--right--uk4GN";